import classnames from 'classnames'
import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { Avatar, Icon, Typography } from 'shared/ui'
import { formatPhoneNumberInternational } from 'shared/lib'
import { type IContactAll } from 'entities/Contacts'
import { useResultsContext } from 'pages/conversations/pages/search/ui/Results/context/resultsContext'
import { HighlighterText } from 'pages/conversations/pages/search/ui/Results/ui/HighlighterText/HighlighterText'
import styles from './styles.module.scss'

type IContactCardProps = {
  item: IContactAll
  onActionClick: (item: IContactAll) => void
  isHideIconIntegration?: boolean
}

export const ContactCard: FC<IContactCardProps> = observer(
  ({ item, onActionClick, isHideIconIntegration }) => {
    const { search } = useResultsContext()
    const number = formatPhoneNumberInternational(item.national_number)

    return (
      <div
        className={styles.wrap}
        onClick={() => {
          onActionClick(item)
        }}
      >
        <div className={styles.info}>
          <div className={styles.avatar}>
            <Avatar info={item.avatarInfo} size={32} />
          </div>
          <div className={styles.info__content}>
            {item.full_name && (
              <Typography
                className={styles.info__name}
                ariaLabel={'info__name'}
                variant={'body-md-medium'}
                ellipsis
              >
                <HighlighterText search={search} text={item.full_name} />
              </Typography>
            )}

            {number && (
              <Typography
                className={styles.info__phone}
                ariaLabel={'info__phone'}
                variant={item.full_name ? 'body-md-regular' : 'body-md-medium'}
              >
                <HighlighterText search={search} text={number} />
              </Typography>
            )}
          </div>
        </div>
        <div className={styles.emailSection}>
          <Typography
            ellipsis
            className={styles.email}
            ariaLabel={'email'}
            variant={'body-md-regular'}
          >
            {item.email ? <HighlighterText search={search} text={item.email} /> : '-'}
          </Typography>
        </div>

        <div
          className={classnames(styles.icon_integration, {
            [`${styles.icon_integration__hide}`]: isHideIconIntegration,
          })}
        >
          <Icon icon={item.localIcon} fontSize={14.7} />
        </div>
      </div>
    )
  }
)
